import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  template: `
    <div class="centered-container">
      <div class="card">
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <h2>Compte Activé !</h2>
        <p class="message">Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter.</p>
        <button class="btn-primary" (click)="goToLogin()">
          Se connecter
        </button>
      </div>
    </div>
  `,
  styles: [`
    .centered-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: #f0f2f5;
    }

    .card {
      background-color: #fff;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      width: 100%;
      max-width: 400px;
      text-align: center;
    }

    .success-icon {
      color: #4caf50;
      font-size: 4rem;
      margin-bottom: 1rem;
    }

    h2 {
      color: #333;
      margin-bottom: 1rem;
    }

    .message {
      color: #666;
      margin-bottom: 2rem;
      line-height: 1.5;
    }

    .btn-primary {
      width: 100%;
      padding: 0.75rem;
      background-color: #4caf50;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 1rem;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }

    .btn-primary:hover {
      background-color: #43a047;
    }
  `]
})
export class ChangePasswordComponent implements OnInit {

  public message: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private notificationService: NotificationService
  ) {
  }

  ngOnInit() {
    // On peut garder la logique de vérification du token si nécessaire
    // const token = this.route.snapshot.params['token'];
    const token = this.route.snapshot.paramMap.get('token'); // Récupérer le token depuis l'URL

      if (token) {
        this.authService.verifyAccount(token).subscribe({
          next: (response: any) => {
            console.log(response);
            this.message = response.message;
          },
          error: (err: any) => {
            this.notificationService.create('Erreur lors de la mise à jour du mot de passe', 'danger', 2000);
          }
        });
      } else {
        this.notificationService.create('Token inexistant', 'danger', 2000);
      }
  }


  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}